<template>
  <sdCards>
    <template v-slot:title>
      <div class="setting-card-title">
        <sdHeading as="h4">{{ $t('pages.settings.my-profile') }}</sdHeading>
        <span>{{ $t('pages.settings.profile-desc') }}</span>
      </div>
    </template>
    <a-row type="flex" justify="center">
      <a-col :xl="12" :lg="16" :xs="24">
        <BasicFormWrapper>
          <a-form :model="formState" @finish="handleFinish">
            <a-row :gutter="16">
              <a-col :span="12">
                <a-form-Item :label="$t('pages.settings.name')">
                  <a-input v-model:value="formState.name" required />
                </a-form-Item>
              </a-col>
              <a-col :span="12">
                <a-form-Item :label="$t('pages.settings.surname')">
                  <a-input v-model:value="formState.surname" required />
                </a-form-Item>
              </a-col>
            </a-row>
            <a-form-item :label="$t('pages.settings.phone')">
              <a-input v-model:value="formState.phone" />
            </a-form-item>
            <a-form-item :label="$t('pages.settings.website')">
              <a-input v-model:value="formState.website" />
            </a-form-item>
            <a-form-item :label="$t('pages.settings.about')">
              <a-textarea v-model:value="formState.biography" :rows="3" />
            </a-form-item>
            <sdButton size="default" htmlType="submit" type="primary">{{ $t('pages.settings.save-change') }} </sdButton>
          </a-form>
        </BasicFormWrapper>
      </a-col>
    </a-row>
  </sdCards>
</template>
<script>
import { BasicFormWrapper } from '../../styled';
import { mapGetters } from 'vuex';
export default {
  name: 'Profile',
  components: { BasicFormWrapper },
  data() {
    return {};
  },
  methods: {
    handleFinish() {
      const form = {
        name: this.formState.name,
        surname: this.formState.surname,
        phone: this.formState.phone,
        website: this.formState.website,
        biography: this.formState.biography,
      };
      this.$appAxios.post(this.$endpoints.profile_set, form).then((resp) => {
        if (resp.data.status) {
          this.$message.success(this.$t('common.success-message'));
        } else {
          this.$message.error(resp.data.message);
        }
      });
    },
  },
  computed: {
    ...mapGetters({
      formState: 'setting/user_info',
    }),
  },
};
</script>
